'use client'
import dynamic from 'next/dynamic'
import { DateFormat } from '@/constants/Common'
const RatingStar = dynamic(() => import('@/components/common/RatingStar'))

const ProductReviewList = (props: any) => {
  const AvrageRateing = props.avg_review.avg_review
  const ProductReviews = props.reviews

  return (
    <div className="col-md-12 col-lg-6">
      {ProductReviews.length > 0 ? (
        <h2>
          Reviews
          <span>({AvrageRateing})</span>
          <div className="average-reviews">
            <RatingStar
              rating={AvrageRateing}
              interactive={false}
            />
            <span className="review-counter"> out of 5</span>
          </div>
        </h2>
      ) : (
        ''
      )}
      {ProductReviews.map((item: any, itemIndex: number) => (
        <div
          className="row review-user-list"
          key={itemIndex}
        >
          <div className="col-md-2 col-lg-2">
            <div className="review-user-img">
              <img
                className="left-arrow"
                src={
                  process.env.NEXT_PUBLIC_S3_BUCKET_URL + 'assets/images/user-icon.svg'
                }
                alt={item.name}
                width="70"
              />
              <span> {item.name}</span>
            </div>
          </div>
          <div className="col-md-10 col-lg-10 review-user-details">
            <h3>{item.title}</h3>
            <RatingStar
              rating={item.rating}
              interactive={false}
            />
            <p className="review-user-content">{item.review}</p>
            <p className="review-date">
              {DateFormat(item.created_at)}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default ProductReviewList
